import { mapGetters } from 'vuex';

export const formatWindowTimeLeft = timeLeft => {
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);

  if (hours && minutes) {
    return `${hours}h e ${minutes}min`;
  }

  if (hours) {
    return `${hours}h`;
  }

  return `${minutes}min`;
};

export default {
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    messagingWindowTimeRemaining() {
      return this.currentChat?.messaging_window_time_remaining || 0;
    },
    formattedTimeLeft() {
      return formatWindowTimeLeft(this.messagingWindowTimeRemaining);
    },
    closingWindowText() {
      return `${this.$t('CONTACT_PANEL.CLOSING_WINDOW_IN')} ${
        this.formattedTimeLeft
      }`;
    },
    showTimer() {
      return (
        this.messagingWindowTimeRemaining > 0 &&
        this.currentChat.status !== 'resolved'
      );
    },
    freeEntryPointTimeRemaining() {
      return this.currentChat?.free_entry_point_time_remaining || 0;
    },
    formattedFreeEntryPointTimeLeft() {
      return formatWindowTimeLeft(this.freeEntryPointTimeRemaining);
    },
    freeEntryPointWindowText() {
      return `${this.$t(
        'CONTACT_PANEL.CLICK_TO_WHATSAPP_FREE_TEMPLATE_WINDOW_IN'
      )} ${this.formattedFreeEntryPointTimeLeft}`;
    },
    showFreeEntryPointTimer() {
      return (
        !!this.currentChat?.click_to_whatsapp_lead &&
        this.freeEntryPointTimeRemaining > 0 &&
        this.currentChat.status !== 'resolved'
      );
    },
  },
};
